import { useIntl } from "react-intl";
import styles from "./MessagesForGuest.module.css";
import { APP_ICONS } from "Assets/icons";
import useAuth from "hooks/useAuth";
import { PATHS } from "constants/routes";

type propsType ={
    isTrail?: boolean
    isUseTrail?: boolean
    setIsUseTrail?: (value: boolean) => void;
}
const MessagesForGuest = (props: propsType) => {
    const {isTrail, isUseTrail, setIsUseTrail} = props;
    const t = useIntl();
    const { onDirectRegister, onDirectLogin } = useAuth();

    const listData = [
        {
            icon: APP_ICONS.edit_blue,
            label: t.formatMessage({ id: "list_professional_store" })
        },
        {
            icon: APP_ICONS.engineer_blue,
            label: t.formatMessage({ id: "find_engage_buyers" })
        },
        {
            icon: APP_ICONS.search_blue,
            label: t.formatMessage({ id: "connect_verified_buyers" })
        },
        {
            icon: APP_ICONS.email_blue,
            label: t.formatMessage({ id: "report_buyer_connections" })
        },
    ]

    const handleClickLogin = () => {
        isTrail?  window.open('https://freshdi.fillout.com/premiumlisting', '_blank'):onDirectLogin()
    }

    const handleClickregister = () => {
        isTrail? window.open(PATHS.supplierPricing, "_blank") :onDirectRegister()
    }
    return (
        <div className={styles["mess-guest"]}>
            <div className={styles["container-recommend"]}>
                <span className={styles["title-guest"]}>{t.formatMessage({ id: "vivian_ai_slogan" })}</span>
                <span className={styles["text-guest"]}>{t.formatMessage({ id: "ai_powered_solution" })}</span>
                <div className={styles["div-guest-1"]}>
                    {listData.map((item, index) => (
                        <div key={index}>
                            <img src={item.icon} alt="icon" height={18} width={17} loading="lazy"/>
                            <span>{item.label}</span>
                        </div>
                    ))}
                </div>
                <div className={styles["div-guest-2"]}>
                    <div>
                        <span className={styles["ai-logo-name"]}><img src={APP_ICONS.icon_ai_agent} alt="logo-ai" height={9} width={9} loading="lazy"/>Vivian AI Agent</span>
                        <span className={styles["find-buyer"]}>{t.formatMessage({ id: "find_buyer" })}</span>
                        <span className={styles["find_buyer_intro"]}><img src={APP_ICONS.icon_ai_agent} alt="logo-ai" height={10} width={12} loading="lazy"/>{t.formatMessage({ id: "find_buyer_intro" })}</span>
                        <div className={styles["div-step"]}>
                            <span>1. {t.formatMessage({ id: "product_to_export" })}</span>
                            <span>2. {t.formatMessage({ id: "target_countries" })}</span>
                            <span>3. {t.formatMessage({ id: "preferred_payment_terms" })}</span>
                            <span>4. {t.formatMessage({ id: "preferred_trade_terms" })}</span>
                        </div>
                        <span className={styles["searching_suitable_buyers"]}>{t.formatMessage({ id: "searching_suitable_buyers" })}</span>
                        <div className={styles["input-send"]}>
                            <span>Rice, Viet Nam, T/T , FOB</span>
                            <img src={APP_ICONS.icon_send_blue} alt="send" loading="lazy"/>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div className={styles["line"]} />
                <span className={styles["login_or_signup"]}>{t.formatMessage({ id: isTrail? "explore_ai_agent" : "login_or_signup" })}</span>
                <div className={styles["div-button"]}>
                    <button className={styles["login"]} onClick={() => handleClickLogin()}>
                        {t.formatMessage({ id: isTrail? "start_trial" : "login" })}
                    </button>
                    <button className={styles["sin_up"]} onClick={() => handleClickregister()}>
                        {t.formatMessage({ id: isTrail? "become_premium" : "sign_up" })}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default MessagesForGuest;